import { render, staticRenderFns } from "./FlyingDoctors.vue?vue&type=template&id=6a366120&scoped=true&"
import script from "./FlyingDoctors.vue?vue&type=script&lang=js&"
export * from "./FlyingDoctors.vue?vue&type=script&lang=js&"
import style0 from "./FlyingDoctors.vue?vue&type=style&index=0&id=6a366120&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a366120",
  null
  
)

export default component.exports